/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { ID } from '@gh/common-shared-data';
import { AbstractRestService, arrayOf, identity, optimisticLockingOf, RestSettings } from '@gh/core-data';
import { Observable } from 'rxjs';
import { ChecklistItemDto } from './checklist.dto';
import { ChecklistMapper } from './checklist.mapper';

@Injectable()
export class ChecklistRestService extends AbstractRestService {

  constructor(settings: RestSettings) {
    super(settings);
  }

  create(checklistItem: ChecklistItemDto): Observable<ChecklistItemDto> {
    return this.httpPost(`${this.bp}/sale-check`, checklistItem, optimisticLockingOf(ChecklistMapper));
  }

  delete(id: ID): Observable<ChecklistItemDto> {
    return this.httpDelete(`${this.bp}/sale-check/${id}`, void 0, optimisticLockingOf(ChecklistMapper));
  }

  update(checklistItem: ChecklistItemDto): Observable<ChecklistItemDto> {
    return this.httpPut(`${this.bp}/sale-check/${checklistItem.id}`, checklistItem, optimisticLockingOf(ChecklistMapper));
  }

  updateOrder(order: ChecklistItemDto[]): Observable<any> {
    return this.httpPut(`${this.bp}/sale-check/drag`, order.map(({ id, etag }) => ({ id, etag })), identity());
  }

  get(id: ID): Observable<ChecklistItemDto> {
    return this.httpGet(`${this.bp}/sale-check/${id}`, optimisticLockingOf(ChecklistMapper));
  }

  findAll(): Observable<ChecklistItemDto[]> {
    return this.httpGet(`${this.bp}/sale-check`, {}, void 0, arrayOf(ChecklistMapper));
  }
}
